import {TranslateService} from '@ngx-translate/core';
import {Component} from '@angular/core';
import * as moment_ from 'moment';
import { TranslatePoolSupportComponent } from '../translate-pool-support/translate-pool-support.component';
const moment = moment_;

//多选
@Component({
    selector: 'lib-selection-support',
    template: ``,
    styles: [``]
})
export class SelectionSupportComponent extends TranslatePoolSupportComponent {
    listOfDisplayData = [];
    isAllDisplayDataChecked = false;
    isIndeterminate = false;
    mapOfCheckedId: { [key: string]: boolean } = {};
    numberOfChecked = 0;

    constructor(
        // tslint:disable-next-line:variable-name
       private _translateService: TranslateService
    ) {
        super(_translateService);
    }

    refreshStatus(): void {
        this.isAllDisplayDataChecked = this.listOfDisplayData
            .filter(item => !item.disabled)
            .every(item => this.mapOfCheckedId[item.id]);
        this.isIndeterminate =
            this.listOfDisplayData.filter(item => !item.disabled).some(item => this.mapOfCheckedId[item.id]) &&
            !this.isAllDisplayDataChecked;
        this.numberOfChecked = this.listOfDisplayData.filter(item => this.mapOfCheckedId[item.id]).length;
    }

    checkAll(value: boolean): void {
        this.listOfDisplayData.filter(item => !item.disabled).forEach(item => (this.mapOfCheckedId[item.id] = value));
        this.refreshStatus();
    }

    checkByIds(ids: any[]) {
        if (ids) {
            this.mapOfCheckedId = {};
            ids.forEach(id => this.mapOfCheckedId[id] = true);
        }
    }

    checkByItems(items: any[]) {
        if (items) {
            const ids = items.map(item => item.id);
            this.checkByIds(ids);
        }
    }

    getCheckedData() {
       return this.listOfDisplayData
            .filter(item => !item.disabled && this.mapOfCheckedId[item.id]);
    }

    getConvertedTime(time) {
        if (time !== undefined) {
            return moment().startOf('d').add(time, 'm').valueOf();
        } else {
            return null;
        }
    }
}
